import { useEffect, useState } from "react";
import { Drawer } from "@mui/material";
import { useBloqueos, useCreateBloqueo, useDeleteBloqueo } from "../../api/aulas";
import { BloqueoForm } from "./BloqueoForm";
import type { Bloqueo } from "../../types/aulas";
import api from "../../api/axios";

// Tipo del formulario que recibimos desde BloqueoForm
type NewBloqForm = {
  dow: Bloqueo["dow"][];
  hora_inicio: string;
  hora_fin: string;
  fecha_inicio: string;
  fecha_fin: string;
  motivo?: string;
  permanente?: boolean; // ← NUEVO
};

export function BloqueosDrawer({
  aulaId,
  open,
  onClose,
}: {
  aulaId: number;
  open: boolean;
  onClose: () => void;
}) {
  const { data: bloqueos = [] } = useBloqueos(aulaId);
  const createBloq = useCreateBloqueo(aulaId);
  const delBloq = useDeleteBloqueo(aulaId);
  const [showNew, setShowNew] = useState(false);

  // Mostrar el NOMBRE del aula (fallback al #id si no disponible)
  const [aulaNombre, setAulaNombre] = useState<string | null>(null);
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await api.get<any>(`/aulas/${aulaId}`);
        if (!mounted) return;
        setAulaNombre(data?.nombre ?? data?.name ?? null);
      } catch {
        if (!mounted) return;
        setAulaNombre(null);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [aulaId]);

  async function handleCreate(data: NewBloqForm) {
    // Rango permanente si aplica
    const fi = data.permanente ? "1900-01-01" : data.fecha_inicio;
    const ff = data.permanente ? "2099-12-31" : data.fecha_fin;

    // data.dow es array → creamos un registro por cada día
    for (const d of data.dow) {
      await createBloq.mutateAsync({
        dow: d,
        hora_inicio: data.hora_inicio,
        hora_fin: data.hora_fin,
        fecha_inicio: fi,
        fecha_fin: ff,
        motivo: data.motivo,
        activo: true,
      });
    }
    setShowNew(false);
  }

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <div style={{ width: 420, padding: 16 }}>
        <h3>Bloqueos del aula {aulaNombre ? aulaNombre : `#${aulaId}`}</h3>

        <button onClick={() => setShowNew((v) => !v)}>
          {showNew ? "Cancelar" : "Nuevo bloqueo"}
        </button>

        {showNew && (
          <div style={{ marginTop: 12, padding: 12, border: "1px solid #eee" }}>
            <BloqueoForm
              onSubmit={(raw: any) => {
                const data: NewBloqForm = {
                  ...raw,
                  dow: (raw.dow ?? []).map((n: number) => n as Bloqueo["dow"]),
                };
                return handleCreate(data);
              }}
            />
          </div>
        )}

        <ul style={{ marginTop: 16 }}>
          {bloqueos.map((b) => (
            <li
              key={b.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 6,
              }}
            >
              <span>
                <b>Día</b> {b.dow} · {b.hora_inicio}–{b.hora_fin} · {b.fecha_inicio} → {b.fecha_fin}
                {b.motivo ? ` · ${b.motivo}` : ""}
              </span>
              <button onClick={() => delBloq.mutate(b.id)}>Eliminar</button>
            </li>
          ))}
          {!bloqueos.length && <li>No hay bloqueos</li>}
        </ul>
      </div>
    </Drawer>
  );
}
